// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZmD7","question":"styles_question__37YX0","description":"styles_description__1UiN3"};